export default "__VITE_ASSET__CLnmorG0__"